import Script from "next/script";

export const ZendeskScript = () => (
  <Script
    strategy="beforeInteractive"
    src="https://static.zdassets.com/ekr/snippet.js?key=94e94f92-8ac5-448c-8461-bfa4a94411c5"
    id="ze-snippet"
  />
);
